<template>
  <div>
    <el-drawer
      title="Formularios Solicitados"
      :visible.sync="showDrawerVacacionesReport"
      size="1000px"
      :before-close="closeDrawerDetalles"
      @closed="closeDrawerDetalles"
    >
      <rabbey-table-3
        :columns="ColumnsDetalles2"
        :data="VacationData"
        :actions="actions"
        :loading="autoLoading"
        @rtable-push-action="onPushAction"
      ></rabbey-table-3>
    </el-drawer>
    <DrawerVacaciones
      ref="vacationForm"
      :visible.sync="vacacionDrawer"
      @dialog-closed="getDataForMonth(UserId, Month, year)"
      @update-data="onPushAction(actionRowData)"
    ></DrawerVacaciones>

    <el-dialog title="Rechazar solicitud" :visible.sync="dialogFormVisible">
      <el-form>
        <el-form-item label="Motivo de rechazo">
          <el-input type="textarea" v-model="rejection"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="Rejected(false)">Cancelar</el-button>
        <el-button type="primary" @click="Rejected(true)">Confirmar</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="Ejecucion de Vacaciones"
      :visible.sync="vacationExcecutionVisible"
      :append-to-body="true"
      width="40%"
    >
      <el-row>
        <h3>Estas seguro que deseas ejecutar esta solicitud?</h3>
      </el-row>

      <el-form
        ref="excecutionForm"
        :model="excecutionForm"
        :rules="excecutionFormRules"
        class="demo-ruleForm"
      >
        <el-form-item label="Desea agregar evidencia?" prop="evidence">
          <el-radio-group v-model="excecutionForm.evidence">
            <el-radio :label="false">No</el-radio>
            <el-radio :label="true">Si</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          v-if="excecutionForm.evidence"
          label="Seleccione evidencia"
          prop="evidenceUploadFileList"
        >
          <el-upload
            class="upload-demo"
            ref="evidenceUpload"
            drag
            action="https://apicloud.magycorp.com:48028/api/gallery/uploadanyFile"
            :on-success="handleSuccess"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :on-error="handleError"
            :file-list="excecutionForm.evidenceUploadFileList"
            :multiple="false"
            :limit="1"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              Arrastra el archivo o <em>haz click para agregarlo</em>
            </div>
            <!--<div class="el-upload__tip" slot="tip">jpg/png files with a size less than 500kb</div>-->
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" size="small" @click="onCancelExecution"
          >Cancelar</el-button
        >
        <el-button type="primary" size="small" @click="RRHHExecuted"
          >Ejecutar</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ColumnsVacationForMonth from "@/columns/ColumnsVacationForMonth";
import DrawerVacaciones from "@/views/apps/employees/RRHH/Modules/Vacation/DrawerVacaciones.vue";
import Vue from "vue";

const vue = new Vue();
export default {
  name: "VacacionesReportForMes",
  components: {
    DrawerVacaciones
  },
  data() {
    return {
      ColumnsDetalles2: ColumnsVacationForMonth,
      dialogFormVisible: false,
      vacationExcecutionVisible: false,
      excecutionForm: {
        evidence: false,
        evidenceUploadFileList: []
      },
      evidence: "",
      rejection: "",
      actionRow: {},
      confirmDialog: false,
      rowDataUpdate: {},
      methodRedirection: null,
      VacationData: [],
      actions: [
        {
          icon: "el-icon-view",
          label: "Ver",
          command: "view-task-view"
        },
        {
          icon: "el-icon-edit",
          label: "Editar",
          command: "edit-task-edit",
          condition: (row) =>
            ((row.IdEmployee == this.currentUser.EmployeeId ||
              this.IsInRole(this.roles.GerenteRRHH)) &&
              row.RRHH_Approval == "Pendiente" &&
              row.SupervisorApproval == "Pendiente") ||
            ((row.IdSupervisor == this.currentUser.EmployeeId ||
              this.IsInRole(this.roles.GerenteRRHH)) &&
              row.SupervisorApproval == "Aprobado" &&
              row.RRHH_Approval == "Pendiente") ||
            ((this.currentUser.PositionID == 68 ||
              this.IsInRole(this.roles.GerenteRRHH)) &&
              row.SupervisorApproval == "Aprobado" &&
              row.RRHH_Approval == "Aprobado")
        },
        {
          icon: "el-icon-delete",
          label: "Eliminar",
          command: "delete-task-delete",
          condition: (row) =>
            (row.IdEmployee == this.currentUser.EmployeeId ||
              this.IsInRole(this.roles.GerenteRRHH)) &&
            row.RRHH_Approval == "Pendiente" &&
            row.SupervisorApproval == "Pendiente"
        },
        {
          icon: "el-icon-check",
          label: "Supervisor Aprobación",
          command: "approve-task",
          condition: (row) =>
            row.SupervisorApproval == "Pendiente" &&
            row.IdSupervisor == this.currentUser.EmployeeId
        },
        {
          icon: "el-icon-check",
          label: "RRHH Aprobación",
          command: "approve-task-rrhh",
          condition: (row) =>
            row.RRHH_Approval == "Pendiente" &&
            (this.currentUser.PositionID == 68 ||
              this.IsInRole(this.roles.GerenteRRHH))
        },
        {
          icon: "el-icon-close",
          label: "Supervisor Rechazo",
          command: "rejected-task",
          condition: (row) =>
            row.SupervisorApproval == "Pendiente" &&
            row.IdSupervisor == this.currentUser.EmployeeId
        },
        {
          icon: "el-icon-close",
          label: "RRHH Rechazo",
          command: "rejected-task-rrhh",
          condition: (row) =>
            row.RRHH_Approval == "Pendiente" &&
            (this.currentUser.PositionID == 68 ||
              this.IsInRole(this.roles.GerenteRRHH))
        },
        {
          icon: "el-icon-finished",
          label: "Ejecucion Vacaciones",
          command: "execute-task-rrhh",
          condition: (row) =>
            row.RRHH_Approval == "Aprobado" &&
            row.SupervisorApproval == "Aprobado" &&
            (this.currentUser.PositionID == 68 ||
              this.IsInRole(this.roles.GerenteRRHH))
        },
        {
          icon: "el-icon-edit",
          label: "Editar Fecha de Solicitud",
          command: "edit-task-edit",
          condition: (row) =>
            (row.RRHH_Approval == "Aprobado" ||
              row.SupervisorApproval == "Aprobado") &&
            (this.currentUser.PositionID == 127 ||
              this.IsInRole(this.roles.GerenteRRHH) ||
              this.currentUser.PositionID == 96)
        }
      ],
      vacacionDrawer: false,
      actionRowData: false,
      autoLoading: false
    };
  },
  props: {
    showDrawerVacacionesReport: {
      type: Boolean,
      default: false
    },
    UserId: {
      type: Number,
      default: 0
    },
    Month: {
      type: Number,
      default: 0
    },
    year: {
      type: Number,
      default: 0
    }
  },
  watch: {
    showDrawerVacacionesReport() {
      this.getDataForMonth(this.UserId, this.Month, this.year);
    }
  },
  methods: {
    getDataForMonth(employee = null, month = null, year = null) {
      this.autoLoading = true;
      let params = {
        EmployeeID: employee,
        Month: month,
        year: year
      };
      this.$http
        .get("/api/Modules/GetVacationsListByMonth", { params })
        .then((resp) => {
          this.VacationData = resp.data;
        })
        .finally(() => {
          this.autoLoading = false;
        });
    },

    closeDrawerDetalles() {
      this.$emit("dialog-closed");
    },

    async onPushAction(action) {
      this.actionRowData = action;
      let rowFormInfo;
      if (action.row.IdRequest) {
        let params = {
          IdRequest: action.row.IdRequest
        };
        this.$http
          .get("/api/Modules/GetVacationsById", { params })
          .then((resp) => {
            rowFormInfo = resp.data;
          })
          .finally(() => {
            this.autoLoading = false;
          });
      }

      this.vacacionDrawer = true;

      let rowData = {
        task: action.row,
        rowforminfo: rowFormInfo
      };

      switch (action.command) {
        case "view-task-view":
          //console.log('rowData: ', rowData);
          this.$refs.vacationForm.show(rowData, true, false, false);
          break;
        case "edit-task-edit":
          this.$refs.vacationForm.show(rowData, false, false, true);
          break;
        case "delete-task-delete":
          this.$refs.vacationForm.DeleleVacationRequest(rowData);
          break;

        case "approve-task":
          await this.SupervisorApproved(rowData.task);
          break;

        case "approve-task-rrhh":
          await this.RRHHApproved(rowData.task);
          break;

        case "rejected-task-rrhh":
          this.methodRedirection = "rejected-task-rrhh";

          this.dialogFormVisible = true;
          this.rowDataUpdate = rowData.task;

          break;

        case "rejected-task":
          this.methodRedirection = "rejected-task";

          this.dialogFormVisible = true;
          this.rowDataUpdate = rowData.task;

          break;

        case "execute-task-rrhh":
          this.vacationExcecutionVisible = true;
          this.actionRow = rowData.task;
          //await this.RRHHExecuted(rowData.task);
          break;

        case "edit-request-date":
          this.$refs.vacationForm.show(rowData, false, false, true);
          break;
      }
    },

    async SupervisorApproved(row) {
      let FormId = row.IdRequest;
      let reponsable = row.IdEmployee;
      let userApproved = this.currentUser.EmployeeId;
      let updated = false;

      this.$confirm(
        "Estas seguro que deseas aprobar esta solicitud. Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning"
        }
      )
        .then(() => {
          this.autoLoading = true;
          this.$http
            .get("/api/Modules/SupervisorApproved?", {
              params: {
                IdRequest: FormId,
                ResponsableId: reponsable,
                EmployeeID: userApproved
              }
            })
            .then(() => {
              vue.$message({
                message: "Solicitud Aprobada Exitosamente",
                type: "success"
              });
              updated = true;
            })
            .catch((err) => {
              vue.$message({ type: "danger", message: err });
            })
            .finally(() => {
              this.getDataForMonth(this.UserId, this.Month, this.year);
              this.$emit("refreshTable2");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Confirmacion cancelada"
          });
        });
      if (updated) {
        return row;
      }
    },

    async RRHHApproved(row) {
      let FormId = row.IdRequest;
      let reponsable = row.IdEmployee;
      let userApproved = this.currentUser.EmployeeId;
      let updated = false;

      this.$confirm(
        "Estas seguro que deseas aprobar esta solicitud. Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning"
        }
      )
        .then(() => {
          this.autoLoading = true;
          this.$http
            .get("/api/Modules/RRHHApproved?", {
              params: {
                IdRequest: FormId,
                ResponsableId: reponsable,
                EmployeeID: userApproved
              }
            })
            .then(() => {
              vue.$message({
                message: "Solicitud Aprobada Exitosamente RRHH",
                type: "success"
              });
              updated = true;
            })
            .catch((err) => {
              vue.$message({ type: "danger", message: err });
            })
            .finally(() => {
              this.getDataForMonth(this.UserId, this.Month, this.year);
              this.$emit("refreshTable2");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Confirmacion cancelada"
          });
        });
      if (updated) {
        return row;
      }
    },
    async Rejected(value = false) {
      let row = this.rowDataUpdate;
      let FormId = row.IdRequest;
      let reponsable = row.IdEmployee;
      let userApproved = this.currentUser.EmployeeId;
      let rejectionComment = this.rejection;

      let updated = false;

      if (value === false) {
        this.rejection = "";
        this.dialogFormVisible = false;

        this.$message({
          type: "info",
          message: "Confirmacion cancelada"
        });

        return;
      }

      if (this.methodRedirection == "rejected-task-rrhh") {
        this.autoLoading = true;
        this.$http
          .get("/api/Modules/RRHHRejected?", {
            params: {
              IdRequest: FormId,
              ResponsableId: reponsable,
              EmployeeID: userApproved,
              RRHH_RejectionComment: rejectionComment
            }
          })
          .then(() => {
            vue.$message({
              message: "Solicitud Rechazada Exitosamente",
              type: "success"
            });
            updated = true;
          })
          .catch((err) => {
            vue.$message({ type: "danger", message: err });
          })
          .finally(() => {
            this.getDataForMonth(this.UserId, this.Month, this.year);
            this.$emit("refreshTable2");
          });
      } else if (this.methodRedirection == "rejected-task") {
        this.autoLoading = true;
        this.$http
          .get("/api/Modules/SupervisorRejected?", {
            params: {
              IdRequest: FormId,
              ResponsableId: reponsable,
              EmployeeID: userApproved,
              SupervisorRejectionComment: rejectionComment
            }
          })
          .then(() => {
            vue.$message({
              message: "Solicitud Rechazada Exitosamente",
              type: "success"
            });
            updated = true;
          })
          .catch((err) => {
            vue.$message({ type: "danger", message: err });
          })
          .finally(() => {
            this.getDataForMonth(this.UserId, this.Month, this.year);
            this.$emit("refreshTable2");
          });
      }

      this.rejection = "";
      this.dialogFormVisible = false;

      if (updated) {
        return row;
      }

      this.dialogFormVisible = false;
      this.dataRowUpdate = null;
    },

    async RRHHExecuted() {
      let FormId = this.actionRow.IdRequest;
      let reponsable = this.actionRow.IdEmployee;
      let userApproved = this.currentUser.EmployeeId;
      let updated = false;

      this.autoLoading = true;
      this.$http
        .get("/api/Modules/RRHHRExecuted?", {
          params: {
            IdRequest: FormId,
            ResponsableId: reponsable,
            EmployeeID: userApproved,
            executionEvidence: this.evidence,
            roundButton: true
          }
        })
        .then(() => {
          vue.$message({
            message: "Vacaciones en ejecucion",
            type: "success"
          });
          updated = true;
        })
        .catch((err) => {
          vue.$message({ type: "danger", message: err });
        })
        .finally(() => {
          this.getDataForMonth(this.UserId, this.Month, this.year);
          this.$emit("refreshTable2");
          this.vacationExcecutionVisible = false;
          this.excecutionForm.evidenceUploadFileList = [];
        });

      if (updated) {
        return this.actionRow;
      }
    },
    onCancelExecution() {
      this.$message({
        type: "info",
        message: "Ejecucion de vacaciones cancelada"
      });
      this.vacationExcecutionVisible = false;
    },
    handleSuccess(response /*, file, fileList*/) {
      //console.log("response: ",response, "\nfile: ",file, "\nfileList: ",fileList);
      //console.log("evidenceUploadFileList: ", this.excecutionForm.evidenceUploadFileList)
      this.evidence = response[0].Url;
    }
    /*,
    handlePreview(file){

    },
    handleRemove(file, fileList){

    },
    handleError(err, file, fileList) {
      //console.log("err: ", err, "\nfile: ", file, "\nfileList: ", fileList)
    }
    */
  }
};
</script>
